export const getRefreshState = state => state.refreshState;
